export const faqs = [
  {
    q: "黑料专区主要讨论什么内容？",
    a: "我们围绕已经公开的节目、剧集、演出与官方动态，整理出可讨论的话题，覆盖吃瓜话题、热点事件、圈内动态和瓜友观点四个方向，方便你快速知道大家都在聊什么。",
  },
  {
    q: "这些话题是怎么整理出来的？",
    a: "编辑会先确认信息是否来自公开渠道，再把零散说法梳理成话题背景、各方观点和后续进展三部分，尽量让第一次点进来的瓜友也能看懂来龙去脉。",
  },
  {
    q: "我可以参与讨论吗？",
    a: "可以。每个话题页都有讨论区，你可以围绕话题本身发表看法、为认同的评论点赞。我们鼓励对事不对人，把观点讲清楚比站队更重要。",
  },
  {
    q: "评论区会筛掉哪些内容？",
    a: "涉及人身攻击、未公开隐私、明显不实信息的评论会被清理。我们希望这里是一个能放松围观、也能认真聊天的地方。",
  },
  {
    q: "话题会持续更新后续吗？",
    a: "会。只要话题有新的公开进展，编辑就会在原有话题页补充时间线与最新动态，不需要你重新找新的帖子。",
  },
  {
    q: "不想错过热门话题怎么办？",
    a: "可以在首页底部订阅我们的每周话题精选邮件，我们会把当周讨论度最高的话题和瓜友高赞观点整理成一封邮件发给你。",
  },
];